module.exports = __webpack_public_path__ + "static/media/cartIcon.017a1dd5.svg";